module.exports = __webpack_public_path__ + "static/media/proj13_img1.e9a94143.jpg";